module.exports = __webpack_public_path__ + "static/img/function4.0c00c5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon/function4.svg
// module id = VgYU
// module chunks = 11